import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { HttpClient } from '../util/http.service';
import { File } from './file.model';
var FileSearchService = (function () {
    function FileSearchService(httpClient) {
        this.httpClient = httpClient;
        this.searchQuerySubject = new BehaviorSubject(null);
        this.searchQuery = this.searchQuerySubject.asObservable();
    }
    FileSearchService.prototype.changeSearchQuery = function (query) {
        this.searchQuerySubject.next(query);
    };
    FileSearchService.prototype.getSearchQuery = function () {
        return this.searchQuerySubject.getValue();
    };
    FileSearchService.prototype.search = function (query) {
        var _this = this;
        return this.httpClient.get('/api/content/render/false/query/' + query)
            .map(function (res) { return _this.extractDataFilter(res); })
            .catch(function (error) { return _this.handleError(error); });
    };
    FileSearchService.prototype.extractDataFilter = function (res) {
        var treeables = [];
        var obj = JSON.parse(res.text());
        var results = obj.contentlets;
        for (var i = 0; i < results.length; i++) {
            var r = results[i];
            var t = void 0;
            t = Object.assign(new File(), r);
            t.modUserName = r.modUser;
            t.mimeType = r.metaData.contentType;
            t.type = 'file_asset';
            treeables[i] = t;
        }
        return treeables;
    };
    FileSearchService.prototype.handleError = function (error) {
        var errMsg = (error.message) ? error.message :
            error.status ? error.status + " - " + error.statusText : 'Server error';
        if (errMsg) {
            // this.log.error(errMsg);
            console.error('There was an error; please try again : ' + errMsg);
            return Observable.throw(errMsg);
        }
    };
    return FileSearchService;
}());
export { FileSearchService };
FileSearchService.decorators = [
    { type: Injectable },
    { type: Inject, args: ['httpClient',] },
];
/** @nocollapse */
FileSearchService.ctorParameters = function () { return [
    { type: HttpClient, },
]; };
//# sourceMappingURL=file-search.service.js.map